import { APP_TIMEZONE } from './equipeWeekParis.js';

export const POS_CLOCK_FALLBACK_TZ = APP_TIMEZONE;

/**
 * Limite produit (2026-10) : pas de champ `timezone` sur Commercant en base.
 * L'horloge POS lit uniquement des sources Admin déjà disponibles (prop / admin_user.commercant.timezone si un jour exposé).
 * Sinon repli explicite {@link POS_CLOCK_FALLBACK_TZ} — sans inventer d'API ni migration.
 */
export function resolvePosCommercantTimeZoneFromSources({
  commercantTimeZone,
  commercant,
} = {}) {
  const fromProp =
    typeof commercantTimeZone === 'string' ? commercantTimeZone.trim() : '';
  if (fromProp) {
    const resolved = resolvePosDisplayTimeZone(fromProp);
    return {
      ...resolved,
      source: resolved.fallbackUsed ? 'fallback' : 'commercant',
    };
  }
  const embedded =
    typeof commercant?.timezone === 'string'
      ? commercant.timezone.trim()
      : typeof commercant?.fuseauHoraire === 'string'
        ? commercant.fuseauHoraire.trim()
        : '';
  if (embedded) {
    const resolved = resolvePosDisplayTimeZone(embedded);
    return {
      ...resolved,
      source: resolved.fallbackUsed ? 'fallback' : 'commercant',
    };
  }
  const resolved = resolvePosDisplayTimeZone(POS_CLOCK_FALLBACK_TZ);
  return { ...resolved, source: 'fallback' };
}

/**
 * Fuseau affiché POS — repli Europe/Paris si valeur commerce absente ou invalide.
 * N'affecte pas les horodatages métier / fiscaux (affichage UI uniquement).
 */
export function resolvePosDisplayTimeZone(commercantTimeZone) {
  const raw = typeof commercantTimeZone === 'string' ? commercantTimeZone.trim() : '';
  if (!raw) return { timeZone: POS_CLOCK_FALLBACK_TZ, fallbackUsed: true };
  try {
    Intl.DateTimeFormat(undefined, { timeZone: raw }).format(new Date());
    return { timeZone: raw, fallbackUsed: false };
  } catch {
    return { timeZone: POS_CLOCK_FALLBACK_TZ, fallbackUsed: true };
  }
}

/** @param {Date} date @param {string} timeZone */
export function formatPosCaisseClockDate(date, timeZone) {
  return new Intl.DateTimeFormat('fr-FR', {
    timeZone,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

/** @param {Date} date @param {string} timeZone */
export function formatPosCaisseClockTime(date, timeZone) {
  return new Intl.DateTimeFormat('fr-FR', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}

export function formatPosCaisseClockLabel(date, timeZone) {
  return `${formatPosCaisseClockDate(date, timeZone)} · ${formatPosCaisseClockTime(date, timeZone)}`;
}
